import { render, staticRenderFns } from "./Component-Sheltermanage.vue?vue&type=template&id=4bac7be4&"
import script from "./Component-Sheltermanage.vue?vue&type=script&lang=js&"
export * from "./Component-Sheltermanage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports